<h2 class="first_title">Consultazione</h2>
<div export-help></div>
<nav aria-label="Percorso di navigazione">
    <ul class="pathbar amministrazione">
        <li><a [routerLink]="[urlCancelleria]">Cancelleria telematica</a></li>
        <li aria-current="page">Consultazione anonima</li>
    </ul>
</nav>
<div class="content-page-wrapper">
  <div class="standardpanel">

    <div class="titleblock">
      <h3 class="title1levelNoMargin">Consultazione Anonima</h3>
    </div>

    <div class="container_tab_nav">

      <!-- TABLIST -->
      <ul class="nav nav-tabs two" role="tablist" aria-label="Ricerca">

        <li role="presentation" class="tab-link-nav" [style.width.%]="50">
          <button
            type="button"
            role="tab"
            id="tab-role"
            class="btn-link"
            [attr.aria-selected]="currentTab === 'ROLE'"
            [attr.aria-controls]="'panel-role'"
            [class.active]="currentTab === 'ROLE'"
            [class.inactive]="currentTab !== 'ROLE'"
            (click)="switchTab('ROLE')"
          >
            Cerca per ruolo
          </button>
        </li>

        <li role="presentation" class="tab-link-nav" [style.width.%]="50">
          <button
            type="button"
            role="tab"
            id="tab-date"
            class="btn-link"
            [attr.aria-selected]="currentTab === 'DATE'"
            [attr.aria-controls]="'panel-date'"
            [class.active]="currentTab === 'DATE'"
            [class.inactive]="currentTab !== 'DATE'"
            (click)="switchTab('DATE')"
          >
            Cerca per citazione/udienza
          </button>
        </li>

      </ul>

      <!-- TAB CONTENT -->
      <div class="tab-content">

        <!-- PANEL ROLE -->
        <div
          id="panel-role"
          role="tabpanel"
          class="tab-pane fade"
          [class.active]="currentTab === 'ROLE'"
          [class.in]="currentTab === 'ROLE'"
          [hidden]="currentTab !== 'ROLE'"
          [attr.aria-labelledby]="'tab-role'"
        >
          <form *ngIf="roleForm" [formGroup]="roleForm" (ngSubmit)="onSearchRole()">
            <div class="container_fieldset">
              <fieldset class="form-group pb-15">
                <legend>Parametri di consultazione per ruolo</legend>
                <div class="col-xs-12 col-sm-12">
                  <div class="row">
                    <div *ngFor="let question of roleQuestions" [class]="question.size">
                      <dynamic-form-field
                        class="form-element"
                        [form]="roleForm"
                        [question]="question">
                      </dynamic-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <p class="mandatory-color">
                        <em>* Campi obbligatori</em>
                      </p>
                    </div>
                    <div class="col-xs-3 col-sm-3">
                      <button
                        class="btn btn-secondary reset"
                        type="reset"
                        (click)="onResetRole()">
                        Reset
                      </button>
                    </div>

                    <div class="col-xs-3 col-sm-3">
                      <button
                        class="btn btn-primary search"
                        type="submit"
                        [disabled]="roleForm.invalid">
                        Cerca
                      </button>
                    </div>
                  </div>

                </div>
              </fieldset>
            </div>
          </form>
        </div>

        <!-- PANEL DATE -->
        <div
          id="panel-date"
          role="tabpanel"
          class="tab-pane fade"
          [class.active]="currentTab === 'DATE'"
          [class.in]="currentTab === 'DATE'"
          [hidden]="currentTab !== 'DATE'"
          [attr.aria-labelledby]="'tab-date'"
        >
          <form *ngIf="dateForm" [formGroup]="dateForm" (ngSubmit)="onSearchDate()">
            <div class="container_fieldset">
              <fieldset class="form-group pb-15">
                <legend>Parametri di consultazione per giudice e date</legend>

                <div class="col-xs-12 col-sm-12">
                  <div class="row">
                    <div *ngFor="let question of dateQuestions" [class]="question.size">
                      <dynamic-form-field
                        class="form-element"
                        [form]="dateForm"
                        [question]="question">
                      </dynamic-form-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <p class="mandatory-color">
                        <em>* Campi obbligatori</em>
                      </p>
                    </div>

                    <div class="col-xs-3 col-sm-3">
                      <button
                        class="btn btn-secondary reset"
                        type="reset"
                        (click)="onResetDate()">
                        Reset
                      </button>
                    </div>

                    <div class="col-xs-3 col-sm-3">
                      <button
                        class="btn btn-primary search"
                        type="submit"
                        [disabled]="dateForm.invalid">
                        Cerca
                      </button>
                    </div>
                  </div>

                </div>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- RISULTATI -->
    <div aria-live="polite">
      <div *ngIf="hasSearched">
        <div *ngIf="currentSearch === 'FASCICOLI'">
          <app-consultazione-anonima-list-fascicoli [fascicoli]="fascicoli"></app-consultazione-anonima-list-fascicoli>
        </div>
        <div *ngIf="currentSearch === 'RICORSI'">
          <app-consultazione-anonima-list-ricorsi [ricorsi]="ricorsi"></app-consultazione-anonima-list-ricorsi>
        </div>
      </div>
    </div>

  </div>
</div>